const utils = require("./utils");

/**
 *
 * @param {Object} target
 * @param {String} eventName
 * @param {Function} callback
 * @memberOf woosmap.maps.events
 * @returns {*}
 */
function addListener(target, eventName, callback) {
    if (target.addListener !== undefined) {
        return target.addListener(eventName, callback);
    }
    // HACK: maps idle event to Baidu tilesloaded.
    if (eventName === "idle") {
        target.addEventListener("tilesloaded", callback);
        target.addEventListener("moveend", callback);

        return {
            remove: () => {
                target.removeEventListener("tilesloaded", callback);
                target.removeEventListener("moveend", callback);
            },
        };
    }
    target.addEventListener(eventName, callback);

    return { remove: () => target.removeEventListener(eventName, callback) };
}

/**
 *
 * @param {Object} target
 * @param {String} eventName
 * @param {Function} callback
 * @memberOf woosmap.maps.events
 * @returns {*}
 */
function addListenerOnce(target, eventName, callback) {
    if (target.addListener !== undefined) {
        return google.maps.event.addListenerOnce(target, eventName, callback);
    }
    // HACK: maps idle event to Baidu tilesloaded.
    if (eventName === "idle") {
        const eventCallbackFunction = () => {
            callback();
            removeFunction();
        };

        const removeFunction = () => {
            target.removeEventListener("tilesloaded", eventCallbackFunction);
            target.removeEventListener("moveend", eventCallbackFunction);
        };

        target.addEventListener("tilesloaded", eventCallbackFunction);
        target.addEventListener("moveend", eventCallbackFunction);

        return { remove: removeFunction };
    }
    const removeFunction = () => target.removeEventListener(eventName, callback);

    target.addEventListener(eventName, () => {
        callback();
        removeFunction();
    });

    return { remove: removeFunction };
}

/**
 *
 * @param {Object} target
 * @param {google.maps.MapsEventListener} listener
 * @memberOf woosmap.maps.events
 */
function removeListener(target, listener) {
    listener.remove();
}

/**
 *
 * @param {Object} target
 * @param {String} eventName
 * @param {*} data
 * @memberOf woosmap.maps.events
 */
function trigger(target, eventName, data) {
    google.maps.event.trigger(target, eventName, data);
}

module.exports = {
    addListener,
    addListenerOnce,
    removeListener,
    trigger,
};
